var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGolfFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "golf-flag_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.623 8.913v54.549m5.52-7.581c5.08 1.202 8.653 4.019 8.653 7.304 0 4.38-6.344 7.902-14.162 7.902-7.818 0-14.185-3.55-14.185-7.93 0-3.2 3.387-5.96 8.264-7.214m6.09-42.667l22.725 9.505-22.725 9.105",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgODAgODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMzUuNjIyNyA4LjkxMjcyVjYzLjQ2MTVNNDEuMTQzIDU1Ljg4MDlDNDYuMjIzMSA1Ny4wODMyIDQ5Ljc5NjEgNTkuODk5OCA0OS43OTYxIDYzLjE4NDlDNDkuNzk2MSA2Ny41NjUxIDQzLjQ1MTYgNzEuMDg3MyAzNS42MzM5IDcxLjA4NzNDMjcuODE2MyA3MS4wODczIDIxLjQ0OTIgNjcuNTM2OCAyMS40NDkyIDYzLjE1NjdDMjEuNDQ5MiA1OS45NTYyIDI0LjgzNTkgNTcuMTk2MSAyOS43MTI4IDU1Ljk0M00zNS44MDMyIDEzLjI3NTlMNTguNTI4MSAyMi43ODEzTDM1LjgwMzIgMzEuODg2IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPjwvc3ZnPg==";
export { SvgGolfFlag as ReactComponent };